module.exports = __webpack_public_path__ + "media/images/icons/since-badge-white-nl-f3567eba7c084f99fe1b5a95d24fed53.svg";